import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PaymentCollectionRequest } from '../../model/payment/PaymentCollectionRequest';
import { ConfigService } from '../../service/config.service';
import { ErrorHandlingComponent } from '../../error-handling.component';

@Component({
  selector: 'app-payment-mode-upi-payment',
  templateUrl: './payment-mode-upi-payment.component.html',
  styleUrls: ['./payment-mode-upi-payment.component.scss']
})
export class PaymentModeUpiPaymentComponent extends ErrorHandlingComponent implements OnInit {

  public upiPaymentForm: FormGroup;
  public isAmountGreaterThanUPILimit: boolean;
  

  @Input()
  paymentRequest: PaymentCollectionRequest;
  @Output() isFormInstanceCreated: EventEmitter<any> = new EventEmitter<any>();
  constructor(private formBuilder: FormBuilder,private configService: ConfigService) { 
    super();
  }

  async ngOnInit(): Promise<void> {
    await this.initializeForm();
    this.isAmountGreaterThanUPILimit = this.paymentRequest.amount > this.configService.getUPILimitPerDay() ? true : false;
  }

  async initializeForm() {
    this.paymentRequest.paymentDetails.upiDetails = {
      vpa: undefined
    }
    this.upiPaymentForm = this.formBuilder.group({
      vpa: this.formBuilder.control('', [Validators.required, Validators.email])
    })   
    this.isFormInstanceCreated.emit(this.upiPaymentForm);
  } 

  get upiPaymentFormControl () {
    return this.upiPaymentForm.controls;
  } 

  public async onVPAChange(){
    if(this.paymentRequest.amount > this.configService.getUPILimitPerDay()){
      this.upiPaymentForm.controls['vpa'].setErrors({'UPIDailyLimit': true});
    }
  }

  protected errorMessages(): object {
    return {
      vpa: [{
        type: 'UPIDailyLimit',
        message: 'Per day UPI transaction limit is ₹1 Lakh, Please try with other payment mode'
      },
      {
        type: 'required',
        message: 'Please enter a valid UPI ID'
      },
      {
        type: 'email',
        message: 'Please enter a valid UPI ID'
      }
      ]
    };
  }
}
